<template>
  <div id="sg">
    <a href="#gel-main" class="sr-only sr-only-focusable">Skip to main content</a>
    <div v-if="$route.name != 'landing'">
      <Menu/>
      <Body/>
    </div>
    <div v-else>
      <router-view/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from "@/components/Menu.vue";
import Body from "@/components/Body.vue";

export default {
  name: "app",
  components: {
    Menu,
    Body
  }
};
</script>

<style lang="scss">
/* */
</style>